import {
  segmentedItemVariants,
  segmentedShellVariants
} from '@/components/ui/button-variants';
import { useId } from 'react';

export type SegmentItem = {
  id: string;
  label: string;
};

type Props = {
  items: SegmentItem[];
  value: string;
  onChange: (id: string) => void;
  className?: string;
  itemClassName?: string;
  'aria-label'?: string;
};

export function SegmentedControl({
  items,
  value,
  onChange,
  className,
  itemClassName,
  'aria-label': ariaLabel
}: Props) {
  const baseId = useId();

  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={segmentedShellVariants(className)}
    >
      {items.map((item) => {
        const selected = item.id === value;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            id={`${baseId}-${item.id}`}
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            className={segmentedItemVariants({ selected, className: itemClassName })}
            onClick={() => onChange(item.id)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
